const slideshows = document.querySelectorAll(".hero-slideshow");

slideshows.forEach((slideshow) => {
    const slides = slideshow.querySelectorAll(".hero-slide");
    if (!slides.length) return;

    const prevBtn = slideshow.querySelector(".hero-slideshow__arrow--prev");
    const nextBtn = slideshow.querySelector(".hero-slideshow__arrow--next");
    const dots = slideshow.querySelectorAll(".hero-slideshow__dot");

    let current = 0;
    let autoplayTimer = null;
    const speed = Number.parseInt(slideshow.dataset.speed, 10) || 0;

    function showSlide(index) {
        slides[current].classList.remove("active");
        if (dots[current]) dots[current].classList.remove("active");

        current = (index + slides.length) % slides.length;

        slides[current].classList.add("active");
        if (dots[current]) dots[current].classList.add("active");
    }

    function stopAutoplay() {
        if (!autoplayTimer) return;
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
    }

    function startAutoplay() {
        if (speed <= 0 || slides.length <= 1 || autoplayTimer) return;
        autoplayTimer = window.setInterval(() => showSlide(current + 1), speed);
    }

    if (prevBtn) prevBtn.addEventListener("click", () => showSlide(current - 1));
    if (nextBtn) nextBtn.addEventListener("click", () => showSlide(current + 1));

    dots.forEach((dot) => {
        dot.addEventListener("click", () => showSlide(Number(dot.dataset.index)));
    });

    slideshow.addEventListener("mouseenter", stopAutoplay);
    slideshow.addEventListener("mouseleave", startAutoplay);
    document.addEventListener("visibilitychange", () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
    });

    startAutoplay();

    slides.forEach((slide) => {
        let downX = 0;
        let downY = 0;
        let dragged = false;
        const threshold = 10;

        slide.addEventListener("pointerdown", (event) => {
            if (
                event.target.closest(".hero-banner__button") ||
                event.target.closest(".hero-slideshow__arrow") ||
                event.target.closest(".hero-slideshow__dot")
            ) {
                return;
            }

            downX = event.clientX;
            downY = event.clientY;
            dragged = false;
        });

        slide.addEventListener("pointermove", (event) => {
            if (
                Math.abs(event.clientX - downX) > threshold ||
                Math.abs(event.clientY - downY) > threshold
            ) {
                dragged = true;
            }
        });

        slide.addEventListener("pointerup", (event) => {
            if (
                event.target.closest(".hero-banner__button") ||
                event.target.closest(".hero-slideshow__arrow") ||
                event.target.closest(".hero-slideshow__dot")
            ) {
                return;
            }

            const href = slide.dataset.href;
            if (!href || dragged) return;

            const newTab = slide.dataset.newtab === "true";
            if (newTab) window.open(href, "_blank", "noopener");
            else window.location.href = href;
        });

        slide.addEventListener("keydown", (event) => {
            if (event.key !== "Enter" && event.key !== " ") return;

            const href = slide.dataset.href;
            if (!href) return;

            event.preventDefault();
            const newTab = slide.dataset.newtab === "true";
            if (newTab) window.open(href, "_blank", "noopener");
            else window.location.href = href;
        });
    });
});
